import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpeachToText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"speach-to-text, voice-to-text"} maskId="square-filled-radius-0-stroke-1-IconSpeachToText"><path fillRule="evenodd" clipRule="evenodd" d="M6 3V17H5V3H6ZM12 4V9.5H11V4H12ZM9 6V14H8V6H9ZM3 8V12H2V8H3ZM12 11H22V14H21V12H17.5V20H19V21H15V20H16.5V12H13V14H12V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSpeachToText;
